export default __webpack_public_path__ + "static/media/service.766e5a11.svg";